;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/projects/:id/assessment\",\"regex\":\"^/projects/([^/]+)/assessment$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:id/learning-goals\",\"regex\":\"^/projects/([^/]+)/learning-goals$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:id/outline\",\"regex\":\"^/projects/([^/]+)/outline$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:id/overview\",\"regex\":\"^/projects/([^/]+)/overview$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:id/settings\",\"regex\":\"^/projects/([^/]+)/settings$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:id/supplies\",\"regex\":\"^/projects/([^/]+)/supplies$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:id/unit-standards\",\"regex\":\"^/projects/([^/]+)/unit-standards$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:id/lessons/:lessonId/details\",\"regex\":\"^/projects/([^/]+)/lessons/([^/]+)/details$\",\"paramNames\":[\"id\",\"lessonId\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:id/lessons/:lessonId/overview\",\"regex\":\"^/projects/([^/]+)/lessons/([^/]+)/overview$\",\"paramNames\":[\"id\",\"lessonId\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:id/versions\",\"regex\":\"^/projects/([^/]+)/versions$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/projects\"},{\"path\":\"/universal-resources\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.8";import * as Sentry from '@sentry/nextjs'

Sentry.init({
  enabled: Boolean(process.env.NEXT_PUBLIC_VERCEL_ENV),
  enableLogs: true,
  dsn: 'https://1b448180cb37e580da7780ad7af553d1@o4509558454878208.ingest.us.sentry.io/4509757429907456',

  integrations: [
    Sentry.browserTracingIntegration({
      instrumentPageLoad: true,
      instrumentNavigation: true,
      enableInp: true,
      enableElementTiming: true,
    }),
    Sentry.httpClientIntegration(),
    Sentry.replayIntegration(),
  ],

  tracesSampleRate: 1,

  replaysSessionSampleRate: 0,

  replaysOnErrorSampleRate: 1.0,

  debug: false,
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
